export default __webpack_public_path__ + "static/media/36I-117118_-37244_0.4a263697.jpg";